import script from "./contactSection.vue?vue&type=script&setup=true&lang=js"
export * from "./contactSection.vue?vue&type=script&setup=true&lang=js"

import "./contactSection.vue?vue&type=style&index=0&id=07acc9c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07acc9c8"]])

export default __exports__